import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./components/ThemeProvider";
import LoadingScreen from "./components/LoadingScreen";
import Home from "./pages/Home";
import { Toaster } from "./components/ui/sonner";

function App() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const t = setTimeout(() => setLoading(false), 1400);
        return () => clearTimeout(t);
    }, []);

    return (
        <ThemeProvider>
            <div className="App font-body bg-background text-foreground min-h-screen">
                {loading && <LoadingScreen />}
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home />} />
                    </Routes>
                </BrowserRouter>
                <Toaster richColors position="top-right" />
            </div>
        </ThemeProvider>
    );
}

export default App;
